module.exports = __webpack_public_path__ + "img/shot2.559ab7c.png";